import { useCallback } from "react";
import { useLocale } from "./LocaleContext";
import { localizePath } from "./routing";

export function useLocalePath() {
  const { language } = useLocale();

  return useCallback(
    (path) => localizePath(path, language),
    [language]
  );
}
